import { apiClient } from '@/services';
import type { ApiResponse } from '@macroinsight/shared-types';

export async function logout(): Promise<ApiResponse<null>> {
  const response = await apiClient.post<null>('/api/auth/logout', undefined, {
    headers: {
      'User-Agent': typeof window !== 'undefined' ? window.navigator.userAgent : ''
    }
  });

  if (response.success && typeof window !== 'undefined') {
    localStorage.setItem('admin-session-logout', Date.now().toString());
  }

  return response;
}
